angular.module('mtic.components.dashboards.student_general')
.component('studentClassesContainer', {
  templateUrl: 'template.html',
  bindings: {
    onSelect: '<',
    classes: '<',
    isTeacherless: '<',
  },
  controllerAs: 'studentClassesContainer',
  controller($scope, $q, $log, $timeout, StudentDataService, userAccount, api, EventManager, language, LocaleService) {
    var eventManager = new EventManager('studentClassesContainer', $scope);
    const studentClassesContainer = this;
    // var last_clicked_class_id;

    studentClassesContainer.selectClassroom = function(class_id){
      studentClassesContainer.onSelect(class_id);
    }

    studentClassesContainer.getClassTypeCaption = function(moduleResourceType){
      return language.get(moduleResourceType);
    }

    eventManager.listen('open-module-view', function(e, args){
      if(!args){
        //studentClassesContainer.onSelect(studentClassesContainer.last_clicked_class_id);
      }else{
        studentClassesContainer.selectClassroom(args);
      }
    })
  }
});
